import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import classnames from 'classnames';

import Login from './components/Login';
import Features from './components/Features';
import NonProdBanner from './components/NonProdBanner';

import styles from './SignOn.module.scss';

export default function SignOn({
  announcementBodyText,
  announcementLinkText,
  announcementLinkUrl,
  announcementTitleText,
  bgColorHex,
  bgFileName,
  displayAnnouncementPanel,
  isDarkMode,
  currentOrganizationName,
  showNonProdBanner,
  customLogoUrl,
  isGuestRegistrationAllowed,
  errorMessage,
  isRelogin,
  isSessionTimeout,
  refererUrl,
  disclaimer,
  privacyLink,
  tosLink,
  defaultUsername,
  supportUrl,
  titleText,
  hideAttribution,
  productTier,
}) {
  useEffect(() => {
    document.body.classList.toggle('fullScreen', !displayAnnouncementPanel);
  }, [displayAnnouncementPanel]);

  const announcementOptions = {
    title: announcementTitleText,
    body: announcementBodyText,
    linkText: announcementLinkText,
    linkUrl: announcementLinkUrl,
  };

  return (
    <div
      data-theme="default"
      className={classnames(styles.page, {
        [styles.nonprodbanner]: showNonProdBanner,
      })}
    >
      {!!showNonProdBanner && <NonProdBanner />}
      <Login
        companyName={currentOrganizationName}
        customLogoUrl={customLogoUrl}
        isGuestRegistrationAllowed={isGuestRegistrationAllowed}
        errorMessage={errorMessage}
        isRelogin={isRelogin}
        isSessionTimeout={isSessionTimeout}
        refererUrl={refererUrl}
        defaultUsername={defaultUsername}
        disclaimer={disclaimer}
        privacyLink={privacyLink}
        tosLink={tosLink}
        supportUrl={supportUrl}
        titleText={titleText}
        hideAttribution={hideAttribution}
        displayFullScreen={!displayAnnouncementPanel}
        productTier={productTier}
      />
      {displayAnnouncementPanel && !isRelogin && (
        <Features
          announcementOptions={announcementOptions}
          isDarkMode={isDarkMode}
          bgColorHex={bgColorHex}
          bgFileName={bgFileName}
        />
      )}
    </div>
  );
}

SignOn.propTypes = {
  announcementBodyText: PropTypes.string,
  announcementLinkText: PropTypes.string,
  announcementLinkUrl: PropTypes.string,
  announcementTitleText: PropTypes.string,
  displayAnnouncementPanel: PropTypes.bool.isRequired,
  bgColorHex: PropTypes.string,
  bgFileName: PropTypes.string,
  isDarkMode: PropTypes.bool,
  currentOrganizationName: PropTypes.string.isRequired,
  showNonProdBanner: PropTypes.bool.isRequired,
  customLogoUrl: PropTypes.string.isRequired,
  isGuestRegistrationAllowed: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  isSessionTimeout: PropTypes.bool.isRequired,
  refererUrl: PropTypes.string.isRequired,
  defaultUsername: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  privacyLink: PropTypes.string.isRequired,
  tosLink: PropTypes.string,
  supportUrl: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  hideAttribution: PropTypes.bool.isRequired,
  productTier: PropTypes.string.isRequired,
  isRelogin: PropTypes.bool.isRequired,
};

SignOn.defaultProps = {
  announcementBodyText: '',
  announcementLinkText: '',
  announcementLinkUrl: '',
  announcementTitleText: '',
  bgColorHex: '',
  bgFileName: '',
  isDarkMode: false,
  tosLink: '',
};
